/*jslint node: true, browser: true*/

"use strict";

var ko = require("pli/knockout");
var pli = require("pli/forms");
var slickGrid = require("../slickgrid");
var AlternateGrouping = require("../slickgrid/slick.alternategrouping");

//-------------------------------------------
function adaptData(data) {
    /// <summary>
    /// Adapts the grid data JSON object to functional version for grid
    /// </summary>
    return {
        getColumns: function getItem(key) { return data.views && data.views[key]; },
        getItem:    function getItem(i) { return data.items && data.items[i]; },
        getLength:  function getLength() { return data.items && data.items.length; },
        getIndex:   function getIndex(i) { return data.indices ? data.indices[i] : null; },
        getGroups:  function getGroups(i) { return data.groups ? data.groups[i] : null; }
    };
}



//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
// "SelectionFormViewModel" class
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

//-------------------------------------------
function SelectionFormViewModel(ko, pli, selectionForm) {
    /// <summary>
    /// Create new instance of viewmodel for
    /// selection form dialog.
    /// <summary>
    this.data = ko.observable(null);
    this.iconClass = ko.observable(""); // we need an extra observable to set "overwriteCss" flag on it (otherwise we could just use text)
    this.phrase = ko.observable(""); // current search phrase (used during server search)
    this.phraseFocused = ko.observable(false);
    this.state = ko.observable("ready");
    this.state.progressVisible = ko.computed(function () { return this().indexOf("ing") > 0; }, this.state);
    this.text = ko.observable(this._textDefaults); // currently active UI texts and labels ("_textDefaults" combined with "options.text" in "open" method)
    this.progressButton = ko.observable(this._textDefaults.searchingButton);
    this.progressTitle = ko.observable(this._textDefaults.searchingTitle);
    this.progressSubtitle = ko.observable(this._textDefaults.searchingSubtitle);
    this._call = null; // currently active PLI call (either search or get-details)
    this._options = null; // will be set in every "open", reset in "close" calls
    this._slick = null; // will be created every time data changes
    this._$grid = null; // will be initialized in first "open" call

    this.accept = this.accept.bind(this);
    this.close = selectionForm.close = this.close.bind(selectionForm);
    this.closeProgress = this.closeProgress.bind(this);
    this.open = selectionForm.open = this.open.bind(selectionForm);
    this.search = this.search.bind(this);
    this._createGrid = this._createGrid.bind(this);
    this._focusPhrase = function () { this.phraseFocused(true); }.bind(this);
    this._getDetailsComplete = this._getDetailsComplete.bind(this);
    this._handleGridKeyDown = this._handleGridKeyDown.bind(this);
    this._searchComplete = this._searchComplete.bind(this);
    this._selectionChanged = this._selectionChanged.bind(this);

    pli.keys.registerKeymap(selectionForm.id, ko.utils.extend(
        ko.utils.extend({}, pli.config.defaultKeymap),
        {
            "Accept": this.accept,
            "Close": this.close
        }
    ));
    selectionForm.page.keymap = selectionForm.id;

    this.data.subscribe( // we need to delay _createGrid (relative to data-change-notification), because SlickGrid needs its container to be visible + container will be made visible by reacting to data-change-notification
        function selectionFormDataChanged() { setTimeout(this, 1); }, // "this" is bound to "_createGrid" method
        this._createGrid
    );
}


//-------------------------------------------
SelectionFormViewModel.prototype.accept = function acceptSelectionFormViewModel() {
    /// <summary>
    /// Accept currently selected records.
    /// </summary>
    switch (this.state()) {
    case "ready":
        return this.search();
    case "searchingNow":
    case "searchingFailed":
    case "gettingNow":
    case "gettingFailed":
        return this.closeProgress();
    case "selectable":
    case "selected":
        if (this.phraseFocused()) {
            this.search();
        } else {
            var selected = this._slick && this._slick.getSelectedRows();
            if (selected.length) {
                // convert selected row indexes to items
                var i, l, items = [];
                for (i = 0, l = selected.length; i < l; i += 1) {
                    items.push(this._slick.getDataItem(selected[i]));
                }

                // if caller requested search-only selection, notify them
                if (!this._options.getDetailsApi) {
                    var onAccepted = this._options.onAccepted,
                        onAcceptedContext = this._options.onAcceptedContext || this._options;
                    this.close();
                    if (typeof onAccepted === "function") {
                        onAccepted.call(onAcceptedContext, items);
                    }
                } else {
                    // caller requested search-getDetails selection, get details now
                    this.state("gettingNow");
                    this.progressTitle(this.text().gettingTitle);
                    this.progressSubtitle(this.text().gettingSubtitle);
                    this.progressButton(this.text().gettingButton);
                    var getRequestData = (this._options.getDetailsDataBuilder
                        ? this._options.getDetailsDataBuilder(items)
                        : { id: ko.utils.arrayMap(items, function (row) { return row[row.length - 1]; }) }
                    );
                    this._call = pli.call({
                        name: this._options.getDetailsApi,
                        data: getRequestData
                    });
                    this._call.always(this._getDetailsComplete);
                }
            }
        }
        break;
    }
    return false;
};


//-------------------------------------------
SelectionFormViewModel.prototype.close = function closeSelectionForm(options) {
    /// <summary>
    /// Close this selection form. If a call
    /// is currently active (searching or getting
    /// details), "close" method will cancel the call
    /// (instead of closing the selection form).
    /// This behaviour can be suppressed by using
    /// "{ force: true }" options object (forced-close).
    /// </summary>
    /// <remarks>
    /// Assumes "this" is form, and "this.viewModel"
    /// is an instance of SelectionFormViewModel.
    /// <remarks>
    var state = this.viewModel.state();
    if (options && options.force) { // forced close
        state = "ready";
    }

    switch (state) {
    case "searchingNow":
    case "searchingFailed":
    case "gettingNow":
    case "gettingFailed":
        return this.viewModel.closeProgress();

    default:
        pli.forms.close(this.id);
        this.viewModel.data(null);
        this.viewModel._call = null;
        this.viewModel._options = null;
        return false;
    }
};


//-------------------------------------------
SelectionFormViewModel.prototype.closeProgress = function closeSelectionFormProgressView() {
    /// <summary>
    /// Either cancel current PLI call OR dismiss
    /// failure screen for either initial search
    /// or get-details PLI call.
    /// </summary>
    this._call = null;

    switch (this.state()) {
    case "searchingNow":
    case "searchingFailed":
        this.state("ready");
        this.phraseFocused(true);
        break;
    case "gettingNow":
    case "gettingFailed":
        this.state("selected");
        this._slick.focus();
        break;
    }

    return false;
};


//-------------------------------------------
SelectionFormViewModel.prototype.search = function selectionFormViewModelSearch() {
    /// <summary>
    /// Execute a search on the server using
    /// the user-specified phrase.
    /// </summary>
    switch (this.state()) {
    case "ready":
    case "selectable":
    case "selected":
        this.state("searchingNow");
        this.data(null);
        this.progressTitle(this.text().searchingTitle);
        this.progressSubtitle(this.text().searchingSubtitle);
        this.progressButton(this.text().searchingButton);
        this._call = pli.call({
            name: this._options.searchApi,
            data: {
                criteria: this.phrase()
            }
        });
        this._call.always(this._searchComplete);
        break;
    }
    return false;
};


//-------------------------------------------
SelectionFormViewModel.prototype.open = function openSelectionForm(options) {
    /// <summary>
    /// Loads a search selection dialog.
    /// </summary>
    /// <remarks>
    /// Assumes "this" is a form object, and "this.viewModel"
    /// is an instance of SelectionFormViewModel.
    /// <remarks>

    // validation
    if (typeof options !== "object" || typeof options.searchApi !== "string") { throw new Error("options.searchApi is required (string)"); }
    if (typeof options.onAccepted !== "function") { throw new Error("options.onAccepted is required (function)"); }

    // reset
    var viewModel = this.viewModel; // see remarks
    viewModel._options = options;
    viewModel.data(null);
    viewModel.phrase("");
    viewModel.state("ready");
    viewModel.text(ko.utils.extend(ko.utils.extend({}, viewModel._textDefaults), options.text));
    viewModel.iconClass(viewModel.text().iconClass);

    // apply knockout bindings if not bound yet
    if (!viewModel._$grid) {
        viewModel._$grid = this.$form.find(".grid");
        if (this.$form.length) {
            ko.applyBindings(viewModel, this.$form[0]); // dereference "$form" jQuery collection because Knockout expects a raw DOM node
        }
    }

    pli.forms.open(this.id);
    viewModel.phraseFocused(true);
    return false;
};


//-------------------------------------------
SelectionFormViewModel.prototype._createGrid = function createSelectionFormGrid() {
    /// <summary>
    /// Initializes a new slick grid instance
    /// for the current data.
    /// </summary>
    if (this._slick) {
        this._slick.destroy();
        this._slick = null;
    }

    var newData = this.data.peek();
    if (newData && this._$grid && this._$grid.length) {
        // initialize slick.grid
        this._slick = new slickGrid.Grid(
            this._$grid,
            adaptData(newData),
            newData.views.standard,
            { enableColumnReorder: false, multiSelect: !!this._options.multiSelect, rowHeight: 30 }
        );

        // register grid event handlers
        this._slick.onSelectedRowsChanged.subscribe(this._selectionChanged);
        this._slick.onKeyDown.subscribe(this._handleGridKeyDown);
        this._slick.onDblClick.subscribe(this.accept);
        this._slick.registerPlugin(
            new AlternateGrouping({ defaultSort: { field: "0" } })
        );

        // set initial selection
        this._slick.setActiveCell(0, 0);
        this._slick.focus();
    }
};


//-------------------------------------------
SelectionFormViewModel.prototype._getDetailsComplete = function selectionFormGetDetailsComplete(response) {
    if (!this._call || this._call.xhr !== response.clientXhr) {
        if (window.console) { window.console.warn("Ignoring get details response:", response); }
        return;
    }

    this._call = null;
    if (response.isError) {
        this.progressTitle(this.text().gettingFailedTitle);
        this.progressSubtitle((response.result && response.result.message) || "(No details)");
        this.progressButton(this.text().gettingFailedButton);
        this.state("gettingFailed");
    } else { // success
        var onAccepted = this._options.onAccepted,
            onAcceptedContext = this._options.onAcceptedContext || this._options;
        this.close({ force: true });
        if (typeof onAccepted === "function") {
            onAccepted.call(onAcceptedContext, response.result);
        }
    }
};


//-------------------------------------------
SelectionFormViewModel.prototype._handleGridKeyDown = function selectionFormGridKeyDown(e) {
    /// <summary>
    /// This is needed because of slickgrid's terrible
    /// key-event-handling implementation.
    /// </summary>
    switch (e.which) {
    case 9: // tab
        setTimeout(this._focusPhrase, 1); // wait for slickgrid key handling to finish before changing focus
        break;
    case 13: // enter
        this.accept();
        break;
    }
};


//-------------------------------------------
SelectionFormViewModel.prototype._searchComplete = function selectionFormSearchComplete(response) {
    if (!this._call || this._call.xhr !== response.clientXhr) {
        if (window.console) { window.console.warn("Ignoring search response:", response); }
        return;
    }

    this._call = null;
    if (response.isError) {
        this.progressTitle(this.text().searchingFailedTitle);
        this.progressSubtitle((response.result && response.result.message) || "(No details)");
        this.progressButton(this.text().searchingFailedButton);
        this.state("searchingFailed");
    } else { // success
        this.state("selectable");
        if (response.result && response.result.items && response.result.items.length) {
            this.data(response.result);
        } else {
            this.phraseFocused(true);
        }
    }
};


//-------------------------------------------
SelectionFormViewModel.prototype._selectionChanged = function selectionFormSelectionChanged(e, data) {
    /// <summary>
    /// Update state based on current slickgrid
    /// selection (i.e. indirectly enable or
    /// disable accept button).
    /// </summary>
    if (e && e.preventDefault) { e.preventDefault(); }
    switch (this.state()) {
    case "selectable":
        if (data.rows.length) {
            this.state("selected");
        }
        break;
    case "selected":
        if (!data.rows.length) {
            this.state("selectable");
        }
        break;
    }
};


//-------------------------------------------
SelectionFormViewModel.prototype._textDefaults = {
    /// <summary>
    /// Define default texts and labels (can be
    /// overridden in "open" method).
    /// </summary>
    acceptButton: "Accept",
    cancelButton: "Cancel",
    exampleHeader: "Examples",
    examples: ["Calgary", "Pandell"],
    failButton: "Stop",
    gettingButton: "Stop load",
    gettingFailedButton: "Dismiss",
    gettingSubtitle: "Please wait...",
    gettingTitle: "Loading selection details",
    iconClass: "sprite-pickList-16",
    instructionHtml: "Please type a search phrase into the <strong>Search</strong> box and press <strong>[Enter]</strong>",
    searchButton: "Search",
    searchingButton: "Stop search",
    searchingFailedButton: "Dismiss",
    searchingSubtitle: "Please wait...",
    searchingTitle: "Searching",
    searchingFailedTitle: "Search Failed",
    title: "Selection Form"
};



//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
// Initialization
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

module.exports = SelectionFormViewModel;



//////////////////
// WEBPACK FOOTER
// ./app/common-selectionform/selectionForm.js
// module id = 521
// module chunks = 49